import coreApiService from './core.service';

const CONTACT = 'pv/contact';
const LEASE = 'pv/contact/lease-form';
const COMPANY_COURSES_ORDER = 'pv/contact/company-course-form';

export const contactApi = {
    contact: (data: { name?: string; email: string; phone?: string; message: string; token: string }) =>
        coreApiService.post(CONTACT, data),
    contactLease: (data: { name?: string; email: string; phone?: string; message: string; token: string }) =>
        coreApiService.post(LEASE, data),
    companyCoursesOrder: (data: {
        name?: string;
        email: string;
        phone?: string;
        topic: string;
        company?: string;
        participantCount?: string;
        numberOfDays?: string;
        date?: string;
        token: string;
    }) => coreApiService.post(COMPANY_COURSES_ORDER, data),
};
